import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { VerifyRegisterForm } from '@old/features/public/verify-register/verify-register-form';

export function VerifyRegisterPage() {
  return (
    <AuthLayoutComponent>
      <VerifyRegisterForm />
    </AuthLayoutComponent>
  );
}
